import { DomItem, SingleField, TimelineComponentProps } from "../../omnia"
import { VirtualList } from "./VirtualList"

export function FieldsVirtualized(props: TimelineComponentProps) {

    const { vm, viewState } = props
    const { fields } = vm

    const cfg = vm.viewConfig

    const fieldWidth = 250

    const getRowHeight = (_, index: number) => {
        const bottomMargin = 80
        let h = fields[index].height - cfg.fieldHeight
        if (index == (fields.length - 1)) h += bottomMargin
        return h
    }


    const render = (field: DomItem, height: number) => {

        const verticalOffset = field.top + cfg.fieldHeight
        const width = vm.fullWidth + cfg.leftOffset
        const style = { width, height }

        return <SingleField key={field.fieldId} {...{ ...props, field, style, verticalOffset, fieldWidth, component: true }} />

    }

    const getInitScrollPosition = (rect: DOMRectReadOnly) => {

        const leftOffset = ((rect.width - fieldWidth) / 2)
        const scroll = viewState?.scroll

        return {
            left: (scroll?.scrollLeft ?? 0) - leftOffset,
            top: scroll?.scrollTop ?? 0
        }

    }

    const setScrollPosition = ({ left, top, }: { left: number, top: number }, rect: DOMRectReadOnly) => {

        const leftOffset = ((rect.width - fieldWidth) / 2)

        viewState.scroll.scrollTop = top
        viewState.scroll.scrollLeft = left + leftOffset

    }


    return <div className="tl-fields tl-crops">

        <VirtualList {...{
            containerClassName: "virtual-list",
            items: fields,
            render,
            getRowHeight,
            getInitScrollPosition,
            setScrollPosition
        }} />

    </div>

}

